import React from 'react';
import { Grid } from 'semantic-ui-react';
import { Info } from '../../../components/Info';
import { DateToStringDate } from '../../../services/date';
import { maskCpfOrCnpj, maskMoney, maskCnpj } from '../../../services/masks';
import { FieldLabel } from '../../../styles';
import {BondInsuranceForGetBondInsurancesResponseDTO} from "../../../dtos/bond-insurance-list/get-bond-insurances-response.dto";

export type Props = {
  bondInsurance: BondInsuranceForGetBondInsurancesResponseDTO;
};

export const BondInsuranceLegalTenantDetails = (props: Props) => {

  const { legal_tenant } = props.bondInsurance;
  return (
    <>
      <Grid.Row>
        <Info name={'EMPRESA'} value={legal_tenant.company} width={4} />
        <Info name={'CNPJ'} value={maskCnpj(legal_tenant.document)} width={4} />
        <Info name={'E-MAIL'} value={legal_tenant.email} width={4} />
        <Info name={'TELEFONE'} value={legal_tenant.phone} width={4} />
      </Grid.Row>

      <Grid.Row>
        <Info name={'DATA DE CONSTITUIÇÃO'} value={DateToStringDate(legal_tenant.foundation_date)} width={4} />
        <Info name={'ÚLT. ALT. CONTRATUAL'} value={DateToStringDate(legal_tenant.last_contractual_alteration_date)} width={4} />
        <Info name={'CAPITAL SOCIAL (R$)'} value={maskMoney(`${legal_tenant.share_capital}`)} width={4} />
        <Info name={'CAPITAL INTERGRALIZADO (R$)'} value={maskMoney(`${legal_tenant.paid_in_capital}`)} width={4} />
      </Grid.Row>

      <Grid.Row>
        <Info name={'FATURAMENTO ANUAL (R$)'} value={maskMoney(`${legal_tenant.anual_revenue}`)} width={4} />
        <Info name={'NOME CONTATO'} value={legal_tenant.contact_name} width={4} />
        <Info name={'TELEFONE CONTATO'} value={legal_tenant.contact_phone} width={4} />
      </Grid.Row>

      <Grid.Row>
        <Info name={'LOGRADOURO'} value={legal_tenant.street} width={4} />
        <Info name={'NÚMERO'} value={legal_tenant.number} width={4} />
        <Info name={'COMPLEMENTO'} value={legal_tenant.complement} width={4} />
        <Info name={'BAIRRO'} value={legal_tenant.district} width={4} />
      </Grid.Row>

      <Grid.Row>
        <Info name={'CIDADE'} value={legal_tenant.city} width={4} />
        <Info name={'ESTADO'} value={legal_tenant.state} width={4} />
        <Info name={'CEP'} value={legal_tenant.zip_code} width={4} />
      </Grid.Row>

      {legal_tenant.partners.map((partner, index) => {
        return (
          <>
            <Grid.Row style={{ paddingLeft: '15px' }}>
              <FieldLabel style={{ color: '#364445', marginTop: '0px' }}>
                {`${index + 1}º SÓCIO`}
              </FieldLabel>
            </Grid.Row>

            <Grid.Row>
              <Info name={'NOME'} value={partner.name} width={4} />
              <Info name={'CPF'} value={maskCpfOrCnpj(partner.document)} width={4} />
              <Info name={'RENDA'} value={`${partner.percent} %`} width={4} />
              <Info name={'DATA DE ENTRADA'} value={DateToStringDate(partner.date_of_entry)} width={4} />
            </Grid.Row>
          </>
        )
      })}
    </>
  )
}
